// extracted by mini-css-extract-plugin
export default {"melodyVideo":"cM-z","isFullWidth":"dM-z","landingPageVideo":"eM-z","play":"fM-z","iframeVideo":"gM-z","playHidden":"hM-z","fullwidth":"iM-z"};